export default "__VITE_ASSET__CccbaiWm__"